import { Component, signal } from '@angular/core';
import { SequenceFormComponent } from "@app/components/forms/sequence/form.component";
import { SequenceHelperService } from '@app/services/helpers/sequence-helper.service';
import { Router, RouterModule } from '@angular/router';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { SequenceCreate } from '@app/models/sequence.interface';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { HeadMetaComponent } from '@app/components/ui.component';
import { ToastService } from '@app/services/toast.service';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-sequence-create',
    templateUrl: './create.page.html',
    styleUrl: './create.page.scss',
    imports: [
        HeadMetaComponent,
        SequenceFormComponent,
        RouterModule,
        FontAwesomeModule,
        HelpButtonComponent
    ]
})
export class SequenceCreatePage {
  public title = 'New Sequence';
  formValid = signal(false);
  formValue = signal<SequenceCreate | null>(null);

  faArrowLeft = faArrowLeft;

  constructor(
    private sequenceService: SequenceHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    
  }

  create() {
    let val = this.formValue();
    if(val) {
      this.sequenceService.create(val)
        .subscribe({
          next: id => {
            console.log(id)
            if(id) {
              this.router.navigateByUrl('/sequences/' + id);
            }
          },
          error: (err: AppHttpError) => {
            console.log(err.error)
            this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
          }
        });
    }
  }
}
